import {connect} from 'react-redux';
import React from 'react';
import _ from 'lodash';

import Blocklink from '../elements/Blocklink';
import Input from '../elements/forms/Input';
import Screen from './Screen';
import Scrollable from '../elements/Scrollable';
import TopBarEvent from '../elements/TopBar/TopBarEvent';
import Validate from '../validate/Validate';
import { dialogAlert } from '../elements/Dialog/dialogs';

export class EventSponsorMessage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            subject: '',
            message: '',
        };
    }
    render() {
        let {event, sponsor, i18n} = this.props,
            header = (
                <div>
                    <TopBarEvent event={event} returnURL={['/events', event.id, 'sponsor', sponsor.id].join('/')} />
                    <hr />
                </div>
            );

        return (
            <Screen header={header}>
                <Scrollable>
                    <form onSubmit={this.handleSubmit.bind(this)}>
                        <div className="content">
                            <Input type="text" label={i18n['label.subject']} value={this.state.subject} onChange={this.handleChange.bind(this, 'subject')} />
                            <Input
                                type="textarea"
                                label={i18n['label.message']}
                                rows="5"
                                value={this.state.message}
                                onChange={this.handleChange.bind(this, 'message')}
                            />
                        </div>
                        <Blocklink right next type="submit" customColor={event.settings.primary_color}>
                            {i18n['label.submit']}
                        </Blocklink>
                    </form>
                </Scrollable>
            </Screen>
        );
    }
    handleChange(field, value) {
        this.setState({[field]: value});
    }
    async handleSubmit(e) {
        e.preventDefault();

        var subject = this.state.subject.trim(),
            message = this.state.message.trim();

        if (!subject.length) {
            await dialogAlert(this.props.i18n["label.subject.field.can't.be.empty"]);
        } else if (!message.length) {
            await dialogAlert(this.props.i18n["label.message.field.can't.be.empty"]);
        } else {
            app.api.events
                .sendMessageToSponsor(this.props.userId, this.props.sponsor.id, subject, message)
                .then(async () => {
                    await dialogAlert(this.props.i18n['label.successfully.sent']);
                    app.history.push(['/events', this.props.event.id, 'sponsor', this.props.sponsor.id].join('/'));
                })
                .catch(async err => {
                    console.warn(err);
                    await dialogAlert(this.props.i18n['label.message.not.send']);
                });
        }
    }
}

const ConnectedScreen = connect((state, props) => {
    let event = state.events[props.eventId].event;
    return {
        event,
        sponsor: _(event.sponsors).find(sponsor => {
            return sponsor.id == props.sponsorId;
        }),
        i18n: state.i18n.translations,
    };
})(EventSponsorMessage);

export default props => (
    <Validate
        validate={state => {
            let eventId = props.match.params.eventId,
                sponsorId = props.match.params.sponsorId,
                event = state.events[eventId].event,
                sponsor = _(event.sponsors).find(sponsor => {
                    return sponsor.id == sponsorId;
                });
            if (!sponsor) {
                throw new Error('Sponsor not found');
            }
        }}>
        <ConnectedScreen {...props.match.params} />
    </Validate>
);
